import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import useColors from 'hooks/useColors';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import Text from './Text';
import Button from './Button';
import IconInfoTriangle from './icons/IconInfoTriangle';
import Squircle from './Squircle';
import Spacer from './Spacer';
import { rem } from './values';
import IconInfo from './icons/IconInfo';
export const AlertViewNew = ({ title, subTitle, action, onPress, type = 'warning', style, testID, noMargin, withIconInfo, primaryButton, secondaryButton, }) => {
    const colors = useColors();
    return (<TouchableBounceCard onPress={onPress} disabled={!onPress} noMarginTop onDark noMarginBottom withPadding noMargin={noMargin} testID={testID} style={[styles.container, style]}>
      <Squircle color={type === 'info'
            ? colors.elements.statusInformationalLight
            : colors.elements.statusNegativeLight}>
        {withIconInfo ? (<IconInfo width={24} height={24} color={type === 'info'
                ? colors.elements.statusInformational
                : colors.elements.statusNegative}/>) : (<IconInfoTriangle width={24} height={24} color={type === 'info'
                ? colors.elements.statusInformational
                : colors.elements.statusNegative}/>)}
      </Squircle>
      <Spacer.W16 />
      <View style={styles.content}>
        <Text Text-16>{title}</Text>
        <Text TextThin-14 Secondary>
          {subTitle}
        </Text>
        {!!action && (<Text Text-14 color={type === 'info'
                ? colors.text.statusInformational
                : colors.text.statusNegative}>
            {action}
          </Text>)}
        {!!(primaryButton || secondaryButton) && (<View style={styles.buttons}>
            {!!primaryButton && (<Button {...(type === 'info'
                ? { statusInformational: true }
                : { brandReversed: true })} square hug title={primaryButton.title} onPress={primaryButton.onPress} testID={primaryButton.testID}/>)}
            {!!secondaryButton && (<Button {...(type === 'info'
                ? { statusInformationalBorder: true }
                : { brandBorder: true })} square hug title={secondaryButton.title} onPress={secondaryButton.onPress} testID={secondaryButton.testID}/>)}
          </View>)}
      </View>
    </TouchableBounceCard>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    content: {
        flex: 1,
    },
    buttons: {
        flexDirection: 'row',
        gap: rem(8),
        marginTop: rem(12),
    },
});
export default memo(AlertViewNew);
